import * as React from "react";
import {
    useBlocker,
    useBeforeUnload as useBeforeUnloadReactRouter,
} from "react-router-dom";

const useBeforeUnload = (props: IUseBeforeUnloadProps) => {
    // This is for detecting SPA route change, different from window.onbeforeunload which only handles browser refresh/close
    const routeChangeBlocker = useBlocker((a) => {
        return (
            props.isBlocking &&
            a.currentLocation.pathname !== a.nextLocation.pathname
        );
    });

    React.useEffect(() => {
        if (routeChangeBlocker.state === "blocked") {
            const confirmLeave = confirm(
                "Are you sure you want to leave this page? Any unsaved changes will be lost.",
            );
            if (confirmLeave) {
                props.onUnload();
                routeChangeBlocker.proceed();
            } else {
                routeChangeBlocker.reset();
            }
        }

        return () => {
            if (routeChangeBlocker.state === "blocked") {
                routeChangeBlocker.reset();
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [routeChangeBlocker]);

    // There is no reliable way of executing props.onUnload depending on if the user left or not, so just warn the user
    useBeforeUnloadReactRouter((e) => {
        if (props.isBlocking) {
            e.preventDefault();
            return "";
        }
    });
};

interface IUseBeforeUnloadProps {
    isBlocking: boolean;
    onUnload(): void;
}

export default useBeforeUnload;
